"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var react_1 = __importDefault(require("react"));
var styles_1 = require("@material-ui/core/styles");
var slate_1 = require("slate");
var slate_react_1 = require("slate-react");
var clsx_1 = __importDefault(require("clsx"));
var hooks_1 = require("material-ui-popup-state/hooks");
var Menu_1 = __importDefault(require("@material-ui/core/Menu"));
var Hidden_1 = __importDefault(require("@material-ui/core/Hidden"));
var FormatBoldRounded_1 = __importDefault(require("@material-ui/icons/FormatBoldRounded"));
var FormatItalicRounded_1 = __importDefault(require("@material-ui/icons/FormatItalicRounded"));
var FormatUnderlinedRounded_1 = __importDefault(require("@material-ui/icons/FormatUnderlinedRounded"));
var CodeRounded_1 = __importDefault(require("@material-ui/icons/CodeRounded"));
var FormatQuoteRounded_1 = __importDefault(require("@material-ui/icons/FormatQuoteRounded"));
var FormatListNumberedRounded_1 = __importDefault(require("@material-ui/icons/FormatListNumberedRounded"));
var FormatListBulletedRounded_1 = __importDefault(require("@material-ui/icons/FormatListBulletedRounded"));
var InsertPhotoRounded_1 = __importDefault(require("@material-ui/icons/InsertPhotoRounded"));
var FunctionsRounded_1 = __importDefault(require("@material-ui/icons/FunctionsRounded"));
var PlayCircleOutlineRounded_1 = __importDefault(require("@material-ui/icons/PlayCircleOutlineRounded"));
var FormatSizeRounded_1 = __importDefault(require("@material-ui/icons/FormatSizeRounded"));
var LocalParkingRounded_1 = __importDefault(require("@material-ui/icons/LocalParkingRounded"));
var LinkRounded_1 = __importDefault(require("@material-ui/icons/LinkRounded"));
var CloudUploadRounded_1 = __importDefault(require("@material-ui/icons/CloudUploadRounded"));
var CameraAltRounded_1 = __importDefault(require("@material-ui/icons/CameraAltRounded"));
var VerticalSplitRounded_1 = __importDefault(require("@material-ui/icons/VerticalSplitRounded"));
var HeadingOne_1 = __importDefault(require("../icons/HeadingOne"));
var HeadingTwo_1 = __importDefault(require("../icons/HeadingTwo"));
var EditorMarkButton_1 = __importDefault(require("../EditorMarkButton"));
var EditorBlockButton_1 = __importDefault(require("../EditorBlockButton"));
var EditorToolbarButton_1 = __importDefault(require("../EditorToolbarButton"));
var EditorToolbarMenuItem_1 = __importDefault(require("../EditorToolbarMenuItem"));
var helpers_1 = require("../../helpers");
var Button_1 = __importDefault(require("../../../Button"));
var withLinks_1 = require("../../plugins/withLinks");
var imageFileTypes = [
    'image/apng',
    'image/bmp',
    'image/gif',
    'image/jpeg',
    'image/pjpeg',
    'image/png',
    'image/svg+xml',
    'image/tiff',
    'image/webp',
    'image/x-icon',
];
var acceptImageTypes = imageFileTypes.join(', ');
exports.useStyles = styles_1.makeStyles(function (theme) {
    return styles_1.createStyles({
        root: {
            position: 'relative',
            marginLeft: -12,
            paddingTop: 8,
            paddingBottom: 8,
            transition: theme.transitions.create(['opacity'], {
                duration: theme.transitions.duration.standard,
            }),
        },
        toolbar: {
            display: 'flex',
            flexWrap: 'wrap',
            minHeight: 0,
        },
        imageToolbar: {
            justifyContent: 'space-between',
            marginLeft: theme.spacing(1.5),
            marginBottom: theme.spacing(2),
        },
        spacer: {
            display: 'inline-block',
            width: theme.spacing(3),
        },
        fileInput: {
            cursor: 'pointer',
            position: 'absolute',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            opacity: 0,
        },
    });
});
var EditorToolbar = function (_a) {
    var _b = _a.hideOnBlur, hideOnBlur = _b === void 0 ? false : _b, _c = _a.saving, saving = _c === void 0 ? false : _c, _d = _a.controls, controls = _d === void 0 ? [
        'bold',
        'underline',
        'italic',
        'strikethrough',
        'tex',
        'block-formatting',
        'numbered-list',
        'bulleted-list',
        'image',
        'mobile-image',
        'media',
        'link',
        'image-buttons',
    ] : _d, onOpenExtractTextFromImageDialog = _a.onOpenExtractTextFromImageDialog;
    var editor = slate_react_1.useSlate();
    var isFocused = slate_react_1.useFocused();
    var hide = hideOnBlur && !isFocused;
    var blockFormattingPopupState = hooks_1.usePopupState({
        variant: 'popover',
        popupId: 'block-formatting-popup',
    });
    var insertImagePopupState = hooks_1.usePopupState({
        variant: 'popover',
        popupId: 'insert-image-popup',
    });
    var classes = exports.useStyles();
    function showControl(control) {
        return controls.includes(control);
    }
    function insertEmbedMedia(event) {
        event.preventDefault();
        var text = { text: '' };
        var media = { type: 'embed-media', children: [text] };
        slate_1.Transforms.insertNodes(editor, media);
    }
    function handleToggleBlock(format) {
        return function (event) {
            event.preventDefault();
            helpers_1.toggleBlock(editor, format);
            blockFormattingPopupState.close();
        };
    }
    function handleInsertBlock(type) {
        return function (event) {
            event.preventDefault();
            var text = { text: '' };
            var block = { type: type, children: [text] };
            slate_1.Transforms.insertNodes(editor, block);
            insertImagePopupState.close();
        };
    }
    function insertImageUploadBlock(event) {
        if (event.target && event.target.files) {
            event.preventDefault();
            var text = { text: '' };
            var block = {
                type: 'insert-image-upload',
                children: [text],
                file: event.target.files[0],
            };
            slate_1.Transforms.insertNodes(editor, block);
            insertImagePopupState.close();
        }
    }
    function handleInsertTestText1(event) {
        event.preventDefault();
        var text = {
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec auctor arcu velit, eget varius nulla faucibus vel. Nam accumsan dignissim tortor, vitae cursus nibh imperdiet sodales.',
        };
        var block = { type: 'paragraph', children: [text] };
        slate_1.Transforms.insertNodes(editor, block, { at: [0] });
    }
    function handleInsertAnswer(event) {
        event.preventDefault();
        var text = {
            text: 'Answer text',
        };
        var block = { type: 'paragraph', children: [text] };
        slate_1.Transforms.insertNodes(editor, block, { at: [0, 0] });
    }
    function handleInsertExplanation(event) {
        event.preventDefault();
        var text = {
            text: 'Explanation text',
        };
        var block = { type: 'paragraph', children: [text] };
        slate_1.Transforms.insertNodes(editor, block, { at: [1, 0] });
    }
    function handleInsertSummary(event) {
        event.preventDefault();
        var text = {
            text: 'Summary text',
        };
        var block = { type: 'paragraph', children: [text] };
        slate_1.Transforms.insertNodes(editor, block, { at: [2, 0] });
    }
    function openExtractTextFromImageDialog(event) {
        insertImagePopupState.close();
        if (onOpenExtractTextFromImageDialog) {
            onOpenExtractTextFromImageDialog(event);
        }
    }
    return (react_1.default.createElement("div", { className: classes.root, style: { opacity: hide ? 0 : 1 } },
        react_1.default.createElement("div", { className: classes.toolbar },
            showControl('bold') && (react_1.default.createElement(EditorMarkButton_1.default, { format: "bold", alt: "Format bold", tooltip: "Bold", icon: react_1.default.createElement(FormatBoldRounded_1.default, null), disabled: hide })),
            showControl('italic') && (react_1.default.createElement(EditorMarkButton_1.default, { format: "italic", alt: "Format italic", tooltip: "Italic", icon: react_1.default.createElement(FormatItalicRounded_1.default, null), disabled: hide })),
            showControl('underline') && (react_1.default.createElement(EditorMarkButton_1.default, { format: "underline", alt: "Format underline", tooltip: "Underlined", icon: react_1.default.createElement(FormatUnderlinedRounded_1.default, null), disabled: hide })),
            showControl('link') && (react_1.default.createElement(EditorToolbarButton_1.default, { active: withLinks_1.isLinkActive(editor), onMouseDown: function (event) {
                    event.preventDefault();
                    var url = window.prompt('Enter the URL of the link:');
                    if (!url)
                        return;
                    withLinks_1.insertLink(editor, url);
                }, alt: "Insert a link", tooltip: "Insert a link", disabled: hide },
                react_1.default.createElement(LinkRounded_1.default, null))),
            showControl('tex') && (react_1.default.createElement(EditorMarkButton_1.default, { format: "tex", alt: "Format LaTeX", tooltip: "LaTeX", icon: react_1.default.createElement(FunctionsRounded_1.default, null), disabled: hide })),
            react_1.default.createElement("span", { className: classes.spacer }),
            showControl('block-formatting') && (react_1.default.createElement(EditorToolbarButton_1.default, __assign({}, hooks_1.bindTrigger(blockFormattingPopupState), { alt: "Block formatting", tooltip: "Block formatting", disabled: hide }),
                react_1.default.createElement(FormatSizeRounded_1.default, null))),
            showControl('numbered-list') && (react_1.default.createElement(EditorBlockButton_1.default, { format: "numbered-list", alt: "Format numbered list", tooltip: "Numbered list", icon: react_1.default.createElement(FormatListNumberedRounded_1.default, null), disabled: hide })),
            showControl('bulleted-list') && (react_1.default.createElement(EditorBlockButton_1.default, { format: "bulleted-list", alt: "Format bulleted list", tooltip: "Bulleted list", icon: react_1.default.createElement(FormatListBulletedRounded_1.default, null), disabled: hide })),
            react_1.default.createElement("span", { className: classes.spacer }),
            showControl('image') && (react_1.default.createElement(EditorToolbarButton_1.default, __assign({ alt: "Insert an image", tooltip: "Insert image" }, hooks_1.bindTrigger(insertImagePopupState), { disabled: hide }),
                react_1.default.createElement(InsertPhotoRounded_1.default, null))),
            showControl('media') && (react_1.default.createElement(EditorToolbarButton_1.default, { onMouseDown: insertEmbedMedia, alt: "Embed playable media", tooltip: "Embed media", disabled: hide },
                react_1.default.createElement(PlayCircleOutlineRounded_1.default, null))),
            saving && (react_1.default.createElement("span", { style: {
                    position: 'absolute',
                    right: 0,
                    top: 12,
                    borderRadius: 3,
                    padding: '3px 6px',
                    backgroundColor: '#F7F6F3',
                    color: '#AFAEAA',
                } }, "Saving...")),
            react_1.default.createElement(Menu_1.default, __assign({}, hooks_1.bindMenu(blockFormattingPopupState)),
                react_1.default.createElement(EditorToolbarMenuItem_1.default, { icon: react_1.default.createElement(LocalParkingRounded_1.default, null), text: "Paragraph", onMouseDown: handleToggleBlock('paragraph') }),
                react_1.default.createElement(EditorToolbarMenuItem_1.default, { icon: react_1.default.createElement(HeadingOne_1.default, null), text: "Heading 1", onMouseDown: handleToggleBlock('heading-one') }),
                react_1.default.createElement(EditorToolbarMenuItem_1.default, { icon: react_1.default.createElement(HeadingTwo_1.default, null), text: "Heading 2", onMouseDown: handleToggleBlock('heading-two') }),
                react_1.default.createElement(EditorToolbarMenuItem_1.default, { icon: react_1.default.createElement(CodeRounded_1.default, null), text: "Code", onMouseDown: handleToggleBlock('code') }),
                react_1.default.createElement(EditorToolbarMenuItem_1.default, { icon: react_1.default.createElement(FormatQuoteRounded_1.default, null), text: "Block quote", onMouseDown: handleToggleBlock('block-quote') })),
            react_1.default.createElement(Menu_1.default, __assign({}, hooks_1.bindMenu(insertImagePopupState)),
                react_1.default.createElement(EditorToolbarMenuItem_1.default, { icon: react_1.default.createElement(CloudUploadRounded_1.default, null), text: "Upload an image" },
                    react_1.default.createElement("input", { type: "file", accept: acceptImageTypes, className: classes.fileInput, onChange: insertImageUploadBlock })),
                react_1.default.createElement(EditorToolbarMenuItem_1.default, { icon: react_1.default.createElement(LinkRounded_1.default, null), text: "Insert an image from a link", onMouseDown: handleInsertBlock('insert-image-link') }),
                react_1.default.createElement(Hidden_1.default, { only: "xs" },
                    react_1.default.createElement(EditorToolbarMenuItem_1.default, { icon: react_1.default.createElement(CameraAltRounded_1.default, null), text: "Take a picture from your phone", onMouseDown: handleInsertBlock('insert-image-phone') })),
                react_1.default.createElement(EditorToolbarMenuItem_1.default, { icon: react_1.default.createElement(VerticalSplitRounded_1.default, { style: { transform: 'scaleX(-1)' } }), text: "Extract text from an image" },
                    react_1.default.createElement("input", { type: "file", accept: acceptImageTypes, className: classes.fileInput, onChange: openExtractTextFromImageDialog })))),
        react_1.default.createElement(Hidden_1.default, { only: "xs" }, showControl('image-buttons') && (react_1.default.createElement("div", { className: clsx_1.default(classes.toolbar, classes.imageToolbar) },
            react_1.default.createElement(Button_1.default, { size: "small", variant: "text", style: { position: 'relative' }, disabled: hide },
                react_1.default.createElement(CloudUploadRounded_1.default, { style: { marginRight: 8, fontSize: '20px' } }),
                "Upload image",
                react_1.default.createElement("input", { type: "file", accept: acceptImageTypes, className: classes.fileInput, onChange: insertImageUploadBlock })),
            react_1.default.createElement(Button_1.default, { size: "small", variant: "text", onMouseDown: handleInsertBlock('insert-image-phone'), disabled: hide },
                react_1.default.createElement(CameraAltRounded_1.default, { style: { marginRight: 8, fontSize: '20px' } }),
                "Picture from phone"),
            react_1.default.createElement(Button_1.default, { size: "small", variant: "text", style: { position: 'relative' }, disabled: hide },
                react_1.default.createElement(VerticalSplitRounded_1.default, { style: {
                        marginRight: 8,
                        fontSize: '20px',
                        transform: 'scaleX(-1)',
                    } }),
                "Extract text from image",
                react_1.default.createElement("input", { type: "file", accept: acceptImageTypes, className: classes.fileInput, onChange: openExtractTextFromImageDialog })))))));
};
exports.default = EditorToolbar;
//# sourceMappingURL=EditorToolbar.js.map